import { render, staticRenderFns } from "./Footer2.vue?vue&type=template&id=69ddb0ca&scoped=true"
import script from "./Footer2.vue?vue&type=script&lang=js"
export * from "./Footer2.vue?vue&type=script&lang=js"
import style0 from "./Footer2.vue?vue&type=style&index=0&id=69ddb0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ddb0ca",
  null
  
)

export default component.exports